import { Component, OnInit, OnDestroy } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { SpinnerService, UtilsService, Message } from "shared-components";
import { SessionContextService } from '../../../../context/session-context.service';
import { DataProvider } from 'projects/packcert-web/src/app/providers/data.provider';
import { ExpedicionesService } from '../../services/expediciones.service';
import { ExpedicionesContextService } from '../../context/expediciones-context.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { Router } from "@angular/router";

@Component({
    selector: 'app-mantenimiento-expediciones',
    templateUrl: './mantenimiento-expediciones.component.html'
})
export class MantenimientoExpedicionesComponent implements OnInit, OnDestroy {
    public confeccionesExpediciones;
    public activeTab = 1;
    public dropdownInfo = -1;
    public dropdownSection = -1;

    public checkedId = []; // IDs de los elementos seleccionados
    public mainDisabled = true; // inhabilitar checkbox principal si no hay cajas/pallets disponibles
    public availableConfecciones; // para el checkbox principal, eliminamos los registros bloqueados

    // Filtro
    public filtersVisible = true;
    public filtersForm: UntypedFormGroup;
    public denominaciones;
    public campanyas;
    public etiquetadores;
    public almacenes;
    public confecciones;
    public disabledDenominaciones: Subject<boolean> = new Subject();
    public disabledCampanya: Subject<boolean> = new Subject();
    public disabledEtiquetadores: Subject<boolean> = new Subject();
    public disabledAlmacenes: Subject<boolean> = new Subject();
    public disabledConfecciones: Subject<boolean> = new Subject();
    public showEmptyDiv = false; // para separar las fechas en otra fila
    private _filters;
    private paisId: number;
    public denominacionId: number;
    private toCloseSpinner = 0;

    // Paginación
    public itemsPerPage = 10;
    public currentPage = 0;
    public totalItems: number;
    public readonly visiblePages = 3;

    // Ordenación
    public orderBy: string;
    public columnId: string;

    // Modales
    public newEditModal = false;
    public expedicionId: number | null = null;
    public generarExpedicionItems;

    public deleteModal = false;
    public alertModal = false;

    public pdfModal = false;
    public base64Certificado;
    public pdfMode = ''; // sign o view
    private pdfFileName = '';

    public showWarning: boolean;
    public showError: boolean;
    public mensajes = new Array<Message>();

    private readonly destroy$ = new Subject<void>();

    constructor(
        private readonly _router: Router,
        private readonly _translate: TranslateService,
        private _fb: UntypedFormBuilder,
        private readonly _sessionContext: SessionContextService,
        private readonly _dataProvider: DataProvider,
        private readonly _spinnerService: SpinnerService,
        private readonly utilsService: UtilsService,
        private readonly _expedicionesService: ExpedicionesService,
        private readonly _expedicionesContext: ExpedicionesContextService,
    ) { }

    ngOnInit(): void {
        this.filtersForm = this._fb.group({
            pais: ['', Validators.required],
            denominacion: [{ value: '', disabled: true }, Validators.required],
            campanya: [{ value: '', disabled: true }],
            etiquetador: [{ value: '', disabled: true }, Validators.required],
            almacen: [{ value: '', disabled: true }, Validators.required], // se debe filtrar por almacén con todos los roles (admin, etiquetador y auditor)
            finca: [''],
            lote: [''],
            confeccion: [{ value: '', disabled: true }],
            tipoConfeccion: [''],
            fechaInicio: [''],
            fechaFin: [''],
        });

        this._expedicionesContext.mantenimientoExpedicionesFilters = null;
        this.showWarning = true;
        this.mensajes.push({ class: 'warning', message: 'global.info.filterRequired' });
        setTimeout(() => {
            this.showWarning ? this.showWarning = false : null;
        }, 5000);

        this.filtersForm.get('fechaInicio').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.validDates());
        this.filtersForm.get('fechaFin').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.validDates());

        /* Bloquear/desbloquear desplegables y actualizar valor a medida que se seleccionan/vacían filtros.
        Si solo hay 1 elemento en la lista, se selecciona automáticamente (en el caso de País y Denominación se bloquea).
        Listado de Etiquetadores como en la pantalla Designaciones, sin depender de la Campaña */
        this.filtersForm.get('pais').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((pais) => {
            if (pais) {
                this.paisId = pais.id;
                this.getDenominacionesByPais(pais.id);
            } else {
                this.disabledDenominaciones.next(true);
                this.denominaciones = [];
                this.filtersForm.get('denominacion').patchValue('');
                this.filtersForm.get('denominacion').disable();
            }
        });

        if (this._dataProvider.paises?.length === 1) {
            this.filtersForm.get('pais').patchValue(this._dataProvider.paises[0]);
            this.filtersForm.get('pais').disable();
        }

        this.filtersForm.get('denominacion').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((denominacion) => {
            if (denominacion) {
                this.denominacionId = denominacion.id;
                this.getCampanyasByPaisDenominacion(denominacion.id, this.paisId);
                this.getEtiquetadoresByPaisDenominacion(this.paisId, denominacion.id);
            } else {
                this.disabledCampanya.next(true);
                this.campanyas = [];
                this.filtersForm.get('campanya').patchValue('');
                this.filtersForm.get('campanya').disable();

                this.disabledEtiquetadores.next(true);
                this.etiquetadores = [];
                this.filtersForm.get('etiquetador').patchValue('');
                this.filtersForm.get('etiquetador').disable();
            }
        });

        this.filtersForm.get('etiquetador').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((etiquetador) => {
            if (etiquetador) {
                this.getAlmacenesByEtiquetador(etiquetador.id);
                this.getConfeccionesByEtiquetador(etiquetador.id);
            } else {
                this.disabledAlmacenes.next(true);
                this.disabledConfecciones.next(true);
                this.almacenes = [];
                this.confecciones = [];
                this.filtersForm.get('almacen').patchValue('');
                this.filtersForm.get('almacen').disable();
                this.filtersForm.get('confeccion').patchValue('');
                this.filtersForm.get('confeccion').disable();
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public get defaultLanguage() {
        return this._translate.getDefaultLang();
    }

    public get role() {
        return this._sessionContext.sessionUser.role;
    }

    public get isSmallScreen() {
        this.showEmptyDiv = window.innerWidth >= 1764;
        return this._sessionContext.isSmallScreen();
    }

    public get paises() {
        return this._dataProvider.paises;
    }

    public get tiposConfeccion() {
        return this._dataProvider.tiposConfeccion;
    }

    public resetForm() {
        this.filtersForm.patchValue({
            // ya que País y Denominación pueden estar bloqueados si el listado solo tiene 1 elemento
            pais: this.paises.length === 1 ? this.paises[0] : '',
            denominacion: this.denominaciones?.length === 1 ? this.denominaciones[0] : '',
            campanya: '',
            etiquetador: '',
            almacen: '',
            finca: '',
            lote: '',
            confeccion: '',
            tipoConfeccion: '',
            fechaInicio: '',
            fechaFin: '',
        });
    }

    /**
     * Para habilitar/deshabilitar botón "Limpiar filtros"
     */
    public checkValuesForm(): boolean {
        return ((this.filtersForm.get('pais').value && this.filtersForm.get('pais').enabled) ||
            (this.filtersForm.get('denominacion').value && this.filtersForm.get('denominacion').enabled) ||
            this.filtersForm.get('campanya').value ||
            this.filtersForm.get('etiquetador').value ||
            this.filtersForm.get('almacen').value ||
            this.filtersForm.get('finca').value ||
            this.filtersForm.get('lote').value ||
            this.filtersForm.get('confeccion').value ||
            this.filtersForm.get('tipoConfeccion').value ||
            this.filtersForm.get('fechaInicio').value ||
            this.filtersForm.get('fechaFin').value) ? true : false;
    }

    private checkDates(inicio, fin) {
        const inicioD = new Date(inicio);
        const finD = new Date(fin);
        return inicioD <= finD;
    }

    private clearDatesValidators() {
        if (this.filtersForm.get('fechaFin').errors && this.filtersForm.get('fechaFin').errors.includes('Invalid date')) {
            this.filtersForm.get('fechaFin').clearValidators();
            this.filtersForm.get('fechaFin').updateValueAndValidity();
        }
        if (this.filtersForm.get('fechaInicio').errors && this.filtersForm.get('fechaInicio').errors.includes('Invalid date')) {
            this.filtersForm.get('fechaInicio').clearValidators();
            this.filtersForm.get('fechaInicio').updateValueAndValidity();
        }
    }

    private validDates() {
        if (this.filtersForm.get('fechaInicio').value && this.filtersForm.get('fechaFin').value) {
            if (this.checkDates(this.filtersForm.get('fechaInicio').value, this.filtersForm.get('fechaFin').value)) {
                this.clearDatesValidators();
            } else {
                this.filtersForm.get('fechaInicio').setErrors(['Invalid date']);
                this.filtersForm.get('fechaFin').setErrors(['Invalid date']);
            }
            if (this.filtersForm.get('fechaInicio').invalid || this.filtersForm.get('fechaFin').invalid) {
                this.showError = true;
                this.mensajes.push({ class: 'error', message: 'global.fecha.error.finAnteriorInicio' });
            } else {
                this.showError = false;
                this.mensajes = [];
            }
        } else {
            this.clearDatesValidators();
            this.showError = false;
            this.mensajes = [];
        }
    }

    public filtrar() {
        this.validDates();
        if (this.filtersForm.invalid) {
            if (Object.keys(this.filtersForm.controls).some(key => this.filtersForm.get(key).hasError('required'))) {
                this.showError = true;
                this.mensajes.push({ class: 'error', message: 'global.error.required' });
            }
        } else {
            this.applyFilters();
        }
    }

    private getTabData() {
        switch (this.activeTab) {
            case 1:
                this.getConfecciones();
                break;
            default:
                this.getExpediciones();
                break;
        }
    }

    public applyFilters() {
        this.currentPage = 0;
        this._expedicionesContext.mantenimientoExpedicionesFilters = {
            denominacionId: this.filtersForm.get('denominacion')?.value?.id || null,
            campanyaId: this.filtersForm.get('campanya')?.value?.id || null,
            etiquetadorId: this.filtersForm.get('etiquetador')?.value?.id || null,
            almacenId: this.filtersForm.get('almacen')?.value?.id || null,
            desFinca: this.filtersForm.get('finca')?.value || '',
            lote: this.filtersForm.get('lote')?.value || '',
            confeccionId: this.filtersForm.get('confeccion')?.value?.id || null,
            tipoConfeccionId: this.filtersForm.get('tipoConfeccion')?.value ? this.filtersForm.get('tipoConfeccion')?.value?.id : null,
            fechaInicio: this.filtersForm.get('fechaInicio')?.value ?
                this.utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaInicio').value) : '',
            fechaFin: this.filtersForm.get('fechaFin')?.value ?
                this.utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaFin').value) : '',
            numPagina: this.currentPage,
            tamPagina: this.itemsPerPage
        };

        this.getTabData();
    }

    // ------------ Inicio llamadas de desplegables (filtros) ------------
    private getDenominacionesByPais(paisId) {
        let filters = {
            paisId: paisId
        };
        this._spinnerService.showSpinner();
        this._expedicionesService.getDenominacionesByPais(filters).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            if (resp.lista.length > 0) {
                this.denominaciones = resp.lista;
                if (this.denominaciones.length === 1) {
                    this.filtersForm.get('denominacion').patchValue(this.denominaciones[0]);
                    this.filtersForm.get('denominacion').disable();
                    this.disabledDenominaciones.next(true);
                } else {
                    this.filtersForm.get('denominacion').enable();
                    this.disabledDenominaciones.next(false);
                }
            }
        });
    }

    private getCampanyasByPaisDenominacion(denominacionId, paisId) {
        let filters = {
            denominacionId: denominacionId,
            paisId: paisId,
            volcadoHistorico: false
        };

        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._expedicionesService.getCampanyasByPaisDenominacion(filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            // Independientemente del núm. de elementos de la lista, se selecciona automáticamente la campaña más reciente
            if (resp.lista.length > 0) {
                this.campanyas = resp.lista;
                this.campanyas.forEach(campanya => {
                    campanya.des = campanya.anyo.toString();
                });
                this.filtersForm.get('campanya').patchValue(this.campanyas[0]);
                this.filtersForm.get('campanya').enable();
                this.disabledCampanya.next(false);
            }
        });
    }

    private getEtiquetadoresByPaisDenominacion(paisId, denominacionId) {
        let filters = {
            paisId: paisId,
            denominacionId: denominacionId
        };

        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._expedicionesService.getEtiquetadores(filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            if (resp.lista.length > 0) {
                this.etiquetadores = resp.lista;
                this.filtersForm.get('etiquetador').enable();
                this.disabledEtiquetadores.next(false);

                if (this.etiquetadores.length === 1) {
                    this.filtersForm.get('etiquetador').patchValue(this.etiquetadores[0]);
                }
            }
        });
    }

    private checkCloseSpinner() {
        this.toCloseSpinner -= 1;
        if (this.toCloseSpinner === 0) {
            this._spinnerService.hideSpinner();
        }
    }

    private getAlmacenesByEtiquetador(etiquetadorId) {
        let filters = {
            etiquetadorId: etiquetadorId
        };
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._expedicionesService.getAlmacenesByEtiquetador(filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            if (resp.lista.length > 0) {
                this.almacenes = resp.lista;
                this.filtersForm.get('almacen').enable();
                this.disabledAlmacenes.next(false);

                if (this.almacenes.length === 1) {
                    this.filtersForm.get('almacen').patchValue(this.almacenes[0]);
                }
            }
        });
    }

    private getConfeccionesByEtiquetador(etiquetadorId) {
        let filters = {
            etiquetadorId,
            denominacionId: this.denominacionId
        };
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._expedicionesService.getConfeccionesByEtiquetador(filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            if (resp.lista.length > 0) {
                this.confecciones = resp.lista;
                this.filtersForm.get('confeccion').enable();
                this.disabledConfecciones.next(false);

                if (this.confecciones.length === 1) {
                    this.filtersForm.get('confeccion').patchValue(this.confecciones[0]);
                }
            }
        });
    }
    // ------------ Fin llamadas de desplegables (filtros) ------------

    private getConfecciones() {
        this.availableConfecciones = null;
        if (this._expedicionesContext.mantenimientoExpedicionesFilters) {
            this._filters = this._expedicionesContext.mantenimientoExpedicionesFilters;
        } else {
            this.applyFilters();
        }

        this._spinnerService.showSpinner();
        this._expedicionesService.getConfecciones(this._filters).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.confeccionesExpediciones = resp.lista;
            this.totalItems = resp.paginacionMeta.totalCount;
            this.availableConfecciones = this.confeccionesExpediciones.filter(el => el.unidadesDisponibles && el.unidadesDisponibles > 0);
            this.mainDisabled = (this.role === 'Auditor' || this.role === 'Supervisor') || (!this.availableConfecciones || this.availableConfecciones.length === 0);
        }, (error) => {
            this.showError = true;
            this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
        });
    }

    private getExpediciones() {
        if (this._expedicionesContext.mantenimientoExpedicionesFilters) {
            this._filters = this._expedicionesContext.mantenimientoExpedicionesFilters;
        } else {
            this.applyFilters();
        }

        this._spinnerService.showSpinner();
        this._expedicionesService.getExpediciones(this._filters).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.confeccionesExpediciones = resp.lista;
            this.totalItems = resp.paginacionMeta.totalCount;
        }, (error) => {
            this.showError = true;
            this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
        });
    }

    private resetPaginationAndSorting() {
        this.currentPage = 0;
        this.itemsPerPage = 10;
        this.orderBy = '';
        this.columnId = '';

        if (this._filters) {
            this._filters.orderItems = null;
        }
    }

    public changeActiveTab(tab: number): void {
        this.confeccionesExpediciones = null;
        this.resetPaginationAndSorting();
        this.resetDropdownAndCheckboxes();
        this.activeTab = tab;
        this.filtrar(); // ya que en esta pantalla se requiere un filtro previo
    }

    public getPercent(expedicion?, confeccion?) {
        return expedicion && confeccion ? (confeccion * 100 / expedicion).toFixed(2) : 0;
    }

    public toggleDropdownInfo(index: number): void {
        this.dropdownInfo = this.dropdownInfo === index ? -1 : index;
    }

    public toggleDropdownSection(index: number): void {
        this.dropdownSection = this.dropdownSection === index ? -1 : index;
    }

    public getBlockchainLink(txId: string): string {
        const baseUrl = 'https://explore.vechain.org/';
        return txId ? `${baseUrl}transactions/${txId}` : baseUrl;
    }

    /**
     * Marcar/desmarcar todos los checkboxes secundarios al interactuar con el principal
     */
    public handleMainCheckClick() {
        const mainCheckbox = document.getElementById('confeccion-main-check') as HTMLInputElement;
        
        if (mainCheckbox && this.availableConfecciones) {

            if (mainCheckbox.checked) {
                this.checkedId = this.availableConfecciones.map(el => el.id);
            } else {
                this.checkedId = [];
            }
        }
    }

    /**
     * Actualizar listado de checkboxes marcados y estado del principal en consecuencia
     */
    public handleSecondaryChecksValue(checked: boolean, id: number) {
        if (checked) {
            this.checkedId.push(id);
        } else {
            this.checkedId = this.checkedId.filter(el => el !== id);
        }
    }

    /**
     * Para los iconos de los Certificados
     */
    public getCheckIconColor(estadoId: number) {
        switch (estadoId) {
            case 1: // Pendiente
                return { color: '#005ccc' };
            case 2: // Concedido o Válido
                return { color: '#2e9900' };
            case 3: // Retirado o Inválido
                return { color: '#e61717' };
            case 4: // Cancelado
                return { color: '#cc7614' };
            case 5: // Expirado
                return { color: '#d4d4d4' };
        }
    }

    public getCheckIconTitle(estadoId: number) {
        switch (estadoId) {
            case 1:
                return this._translate.instant('global.tipoEstado.pending');
            case 2:
                return this._translate.instant('global.tipoEstado.valid');
            case 3:
                return this._translate.instant('global.tipoEstado.invalid');
            case 4:
                return this._translate.instant('global.tipoEstado.canceled');
            case 5:
                return this._translate.instant('global.tipoEstado.expired');
        }
    }

    /**
     * Al hacer un cambio de página/elementos manualmente
     */
    private resetDropdownAndCheckboxes() {
        this.dropdownInfo = -1;
        this.dropdownSection = -1;
        this.checkedId = [];
    }

    public pageChange(page) {
        this.resetDropdownAndCheckboxes();
        this._expedicionesContext.mantenimientoExpedicionesFilters.numPagina = this.currentPage = page - 1;
        this.getTabData();
    }

    public itemsPerPageChange(items) {
        this.resetDropdownAndCheckboxes();
        this._expedicionesContext.mantenimientoExpedicionesFilters.numPagina = this.currentPage = 0;
        this._expedicionesContext.mantenimientoExpedicionesFilters.tamPagina = this.itemsPerPage = items;
        this.getTabData();
    }

    public toOrderBy(columnFilter: string, colId: string) {
        this.columnId = colId;

        if (this.confeccionesExpediciones && this.confeccionesExpediciones.length > 0 && 
            this._expedicionesContext.mantenimientoExpedicionesFilters) {
            this._filters = this._expedicionesContext.mantenimientoExpedicionesFilters;
            const isAscending  = !this.orderBy || this.orderBy.includes('DESC');
            this.orderBy = isAscending ? 'ASC' + colId : 'DESC' + colId;
            this._filters.orderItems = [
                {
                    orderProperty: columnFilter,
                    orderByDescending: !isAscending
                }
            ];
            this.getTabData();
        }
    }

    public getIcon(colId: string) {
      let iconClass = 'fa fa-sort';

      if (this._filters?.orderItems && colId === this.columnId) {
          iconClass = this._filters.orderItems[0]?.orderByDescending === true ? 'fa fa-sort-down' : 'fa fa-sort-up';
      }
      return iconClass;
    }

    public showNewEditModal(expedicionId: number | null = null) {
        if (!expedicionId) {
            this.generarExpedicionItems = this.confeccionesExpediciones.filter(el => {
                return this.checkedId.includes(el.id);
            });
        }

        this.expedicionId = expedicionId;
        this.newEditModal = true;
    }

    /**
     * Mostrar toast tras recibir mensaje desde el componente hijo new-edit de expedición
     */
    public pushMessage(mensaje) {
        this.showError = true;
        if (mensaje.includes('error') || mensaje.includes('ApiErrors')) {
            this.mensajes.push({ class: 'error', message: mensaje });
        } else {
            this.mensajes.push({ class: 'success', message: mensaje });
        }
    }

    /**
     * Posible refresco de datos tras cierre del new-edit de expedición
     */
    public refresh(value: boolean) {
        this.newEditModal = false;

        if (value) {
            this.checkedId = []; // desmarcamos los checkboxes tras crear
            this.getTabData();
        }
    }

    public showDeleteModal(expedicionId: number) {
        this.expedicionId = expedicionId;
        this.deleteModal = true;
    }

    public closeDeleteModal() {
        this.deleteModal = false;
    }

    public deleteExpedicion() {
        this._spinnerService.showSpinner();
        this._expedicionesService.deleteCertificadoExpedicion(this.expedicionId).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.deleteModal = false;
            this.showError = true;
            this.mensajes.push({ class: 'success', message: 'global.success.itemDeleted' });
            this.getExpediciones();
        }, (error) => {
            this.showError = true;
            this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
        });
    }

    public showPdfModal(id: number, mode: string) {
        this.expedicionId = id;
        this.pdfMode = mode;

        this._spinnerService.showSpinner();
        this._expedicionesService.getCertificadoPdf(this.expedicionId).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.base64Certificado = resp.base64Archivo;
            this.pdfFileName = resp.nombreArchivo;
            this.pdfModal = true;
        }, (error) => {
            this.showError = true;
            this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
        });
    }

    public closeSignaturePdfModal() {
        this.pdfModal = false;
    }

    private signCertificado() {
        const filters = {
            certificadoExpedicionId: this.expedicionId,
        };

        this._spinnerService.showSpinner();
        this._expedicionesService.signCertificadoPdf(filters).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.pdfModal = false;
            this.showError = true;
            this.mensajes.push({ class: 'success', message: 'global.success.certificadoFirmado' });
            this.getExpediciones();
        }, (error) => {
            this.pdfModal = false;
            this.showError = true;

            if (error.status === 420 && error.error.ApiErrorCode === 6250) {
                this.mensajes.push({ class: 'error', message: 'global.error.signCertificate' });
            } else {
                this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
            }
        });
    }

    private downloadCertificado() {
        const downloadLink = document.createElement('a');
        downloadLink.href = 'data:application/pdf;base64,' + this.base64Certificado;
        downloadLink.download = this.pdfFileName;
        downloadLink.click();
    }

    public signOrDownlowadCertificado() {
        if (this.pdfMode === 'sign') {
            this.signCertificado();
        } else {
            this.downloadCertificado();
        }
    }

    public showAlertModal() {
        this.alertModal = true;
    }

    public closeAlertModal() {
        this.alertModal = false;
    }

    public openDocHelp() {
        this._spinnerService.showSpinner();

        this._expedicionesService.getDocHelp('Expeditions_Expeditions.pdf').toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            localStorage.setItem('base64', resp.base64Archivo);
            const url = this._router.serializeUrl(this._router.createUrlTree(['viewPdf']));
            window.open(url, '_blank');
        });
    }

    public trackByConfeccionId(index: number, confeccion: { id: number }): number {
        return confeccion.id;
    }

    public trackByExpedicionId(index: number, expedicion: { id: number }): number {
        return expedicion.id;
    }
}